module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "teak-dune-timber-hayman-1.90068b7f.jpg";